export default __webpack_public_path__ + "static/media/community.755a1621.png";